module.exports = {
    development: "https://api-qfb.leyinfupay.cn:",  // 新正式
    production: "https://api-qfb.leyinfupay.cn:"
    // development: "https://api-qfb-test.leyinfupay.cn:",  // 测试
    // production: "https://api-qfb-test.leyinfupay.cn:"
};
// 发起进件 -- 签约 -- 后五个接口


// WEBPACK FOOTER //
// ./src/common/conf/Server.js